import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-ag-radial-bar-series-options',
	templateUrl:'./AgRadialBarSeriesPluginCompPage.html',
	styles: [],
	styleUrls:['./AgRadialBarSeriesPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgRadialBarSeriesPluginCompPage
{
	mdContent_750 = `\`\`\`java
import com.jwebmp.plugins.agchartsenterprise.options.series.AgRadialBarSeriesOptions;
\`\`\``;
}
